<template>
  <v-autocomplete
    :value="value"
    :items="buildingsList"
    :label="label"
    :search-input.sync="search"
    :error-messages="errorMessages"
    :rules="rules"
    :readonly="readonly"
    name="building_ids"
    item-value="id"
    item-text="street"
    clearable
    multiple
    chips
    small-chips
    deletable-chips
    :counter="buildingsList.length"
    v-bind="$attrs"
    v-on="listeners"
  >
    <template v-slot:prepend-item>
      <v-list-item ripple @mousedown.prevent @click="toggle">
        <v-list-item-action>
          <v-icon>
            {{ icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('ITEM.ALL') }} {{ $t('BUILDINGS.ITEMS') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapCacheActions } from 'vuex-cache';
import clearableSelectFilter from '@/modules/plannings/components/filters/mixins/clearableSelectFilter';

export default {
  name: 'BuildingsInput',

  mixins: [clearableSelectFilter],

  props: {
    value: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: [String, Array],
      default: () => []
    },
    rules: {
      type: Array,
      default: () => []
    },
    buildingComplexId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      buildingsList: []
    };
  },

  computed: {
    issetValue() {
      return this.value.length > 0;
    },
    isSelectedAll() {
      return this.buildingsList.length === this.value.length;
    },
    allRegionsValue() {
      return this.buildingsList.map(({ id }) => id);
    },
    isSomeSelected() {
      return this.issetValue && !this.isSelectedAll;
    },
    icon() {
      if (this.isSelectedAll) return 'mdi-close-box';
      if (this.isSomeSelected) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    }
  },

  mounted() {
    this.getBuildings(this.buildingComplexId).then(({ data }) => {
      this.buildingsList = [...data.data];
    });
  },

  methods: {
    ...mapCacheActions('building_complex', ['getBuildings']),
    toggle() {
      if (this.isSelectedAll) {
        this.emitter([]);
      } else {
        this.emitter(this.allRegionsValue);
      }
    }
  }
};
</script>

<style scoped></style>
